import * as R from 'ramda'
import { empty, of } from 'rxjs'
import { distinctUntilChanged, ignoreElements, tap, switchMap, map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { getOpeCodeInPathname, isOneOfOldRoutes } from 'helpers/PathHelper'
import * as Actions from 'store/actions/index.ts'
import { getOperationCode } from 'store/selectors'

// type ReplaceURL = (string, string) => string
const replaceURL = (currentURL, URLToReplace) => {
  if (__PRODUCTION__) {
    return URLToReplace
  }

  const [originFromCurrentURL] = currentURL.split('#')
  const [, URIfromURLToReplace] = URLToReplace.split('#')
  return `${originFromCurrentURL}#${URIfromURLToReplace}`
}

export const saleWillChangeEpic = (actions$) => actions$.pipe(
  ofType(Actions.resources.VIEWED_PRODUCT_SELECTION),
  distinctUntilChanged(),
  tap(({ payload }) => {
    window.location.assign(replaceURL(window.location.href, payload.uri))
  }),
  ignoreElements()
)

export const saleChangesEpic = (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  map(R.path(['payload', 'location', 'pathname'])),
  switchMap(pathname => {
    const initialOperationCode = getOperationCode(state$.value)
    const newOperationCode = getOpeCodeInPathname(pathname)

    return (
      !isOneOfOldRoutes(pathname) &&
      initialOperationCode &&
      newOperationCode &&
      initialOperationCode !== newOperationCode
    )
      ? of(Actions.application.onSaleChanges())
      : empty()
  })
)
